import { NotificationType } from "assets";
import i18n from "i18n/i18n";
import {
  GetNotificationBorderColor,
  NotificationTypeUpdated,
  getTypeColor,
} from "shared-functions/notification";
import { useBoundStore } from "store/store";


interface TypeBadgeProps{
    typecode: number;
    notification: any;
}
function TypeBadge(props: TypeBadgeProps) {

  const lang:any = useBoundStore((state) => state.lang);

  let badgeProps = generateBadgeProps(props);

  function generateBadgeProps(props: any) {
    if (props.typecode !== null) {
      let text = NotificationTypeUpdated(
        Number(props.typecode),
        props?.notification,
        lang
      );
      return {
        status:
          props?.notification?.type === 6
            ? props?.notification?.hasmaintenancetask
              ? props?.notification?.hasmaintenancetask[0]?.maintenancetask
                  ?.hascategory[0]?.maintenancecategory?.colorcode
              : "#000000"
            : getTypeColor(props.typecode),
        text: text,
      };
    } else {
      return {
        status: getTypeColor(undefined),
        text: i18n(lang)?.undefined,
      };
    }
  }
  return (
    <div
      className="typeBadge"
      style={{
        border:
          "1px solid " +
          (+props?.notification?.type === 6
            ? badgeProps.status
            : GetNotificationBorderColor(+props?.notification?.type)),
        color:
          +props?.notification?.type === 6
            ? badgeProps.status
            : GetNotificationBorderColor(+props?.notification?.type),
            WebkitTextStroke:+props?.notification?.type === 7 ? "0.7px gold" : ""
      }}
      
    >
      {NotificationType(Number(props?.notification?.type), lang)}
    </div>
  );
}

export default TypeBadge;
